import allChampions from '@data/allChampions.json';

const anyChamp = allChampions.Aatrox;
export const ddragonVersion = anyChamp.version;
function normalize(str) {
    return str.toLowerCase().replace(/[^a-z0-9]/g, '');
}

const championIndex = Object.values(allChampions).map(champ => ({
    name: champ.name,      // z.B. "Jarvan IV" oder "Rek’sai"
    key: champ.id,         // z.B. "JarvanIV" oder "RekSai"
    normName: normalize(champ.name)
}));

export function getChampionSuggestions(input) {
    const q = normalize(input);
    return championIndex
        .filter(ch => ch.normName.includes(q))
        .slice(0, 5)
        .map(ch => ({ name: ch.name, key: ch.key }));
}
